import { render, staticRenderFns } from "./ProductInstanceBarcodeCreateUpdate.view.vue?vue&type=template&id=7fb22ef6&scoped=true&"
import script from "./ProductInstanceBarcodeCreateUpdate.view.vue?vue&type=script&lang=js&"
export * from "./ProductInstanceBarcodeCreateUpdate.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb22ef6",
  null
  
)

export default component.exports